import React, { memo, useMemo } from "react";

const SummarySection = memo(({ sponsor, sponsoredUsers, sponsoredCount }) => {
  const pendingActivationCount = useMemo(() => {
    return sponsoredUsers.filter((u) => u.needToActiveAccount).length;
  }, [sponsoredUsers]);

  const sponsorStatus = useMemo(() => {
    return sponsor ? "A un parrain" : "Aucun parrain";
  }, [sponsor]);

  const sponsoredStatus = useMemo(() => {
    const plural = sponsoredCount > 1 ? "s" : "";
    return `${sponsoredCount} filleul${plural}`;
  }, [sponsoredCount]);

  const pendingActivationLine = useMemo(() => {
    return pendingActivationCount > 0 ? (
      <div className="text-orange-700">
        • {pendingActivationCount} filleul(s) en attente d'activation
      </div>
    ) : null;
  }, [pendingActivationCount]);

  const shouldShowSummary = useMemo(() => {
    return sponsor || sponsoredUsers.length > 0;
  }, [sponsor, sponsoredUsers.length]);

  return shouldShowSummary ? (
    <div className="bg-blue-50 p-4 rounded">
      <h4 className="font-medium text-blue-900 mb-2">Résumé du réseau</h4>
      <div className="text-sm text-blue-800 space-y-1">
        <div>• {sponsorStatus}</div>
        <div>• {sponsoredStatus}</div>
        {pendingActivationLine}
      </div>
    </div>
  ) : null;
});

export default SummarySection;
